module.exports = __webpack_public_path__ + "img/word.71c68ed4.png";